/**
 * The words the Overview's layout says about the screen itself (the one-screen layout,
 * audits/2026-10-29/gui/principles.md §3) — which panel is which, nothing about X.
 * Everything else the screen says stays in `overview-copy.ts`, `overview-stats-copy.ts`
 * and `format.ts`, as it stood.
 */
export const ACCOUNTS_PANEL = "Ad accounts";
/** Was inline in pages/Overview.tsx, moved as it stood. */
export const SYSTEMS = "Systems";

/** The card's switch for the analytics beside the cards. */
export const SHOW_ANALYTICS = "Show analytics";
export const ANALYTICS_SHOWN = "Analytics shown";
